import React, { useState, useEffect } from 'react';
import authService from '../../../Services/authService';

const PhlebloInfo = ({ data }) => {
    const [OrderInf, setData] = useState({});

    useEffect(() => {
        if (data?.id) {
            loadPhlebloInfo();
        }
    }, [data]);

    const loadPhlebloInfo = () => {
        const token = authService.getCurrentadmin().token;
        const url = new URL(authService.getApiUrl() + 'phleblo/' + data.id);

        fetch(url, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json; charset=UTF-8',
                Authorization: `Bearer ${token}`,
            },
        })
            .then((res) => {
                if (res.status === 401) {
                    authService.logout();
                    window.location.href = "/admin";
                } else {
                    return res.json();
                }
            })
            .then((result) => {
                if (result?.data) {
                    setData(result.data);
                } else {
                    setData({});
                }
            })
            .catch((err) => console.error("Fetch Error:", err));
    };

    return (
        <div style={{ width: '100%', margin: '20px 0' }}>
            <table border="1" cellSpacing="0" cellPadding="10" style={{ width: '100%', textAlign: 'left' }}>
                {/* <thead>
          <tr>
            <th colSpan="4">Phlebotomist Registration Info</th>
          </tr>
        </thead> */}
                <tbody>
                    <tr>
                        <td><strong>Full Name</strong></td>
                        <td>{OrderInf.fullname || 'N/A'}</td>
                        <td><strong>Mobile</strong></td>
                        <td>{OrderInf.mobile || 'N/A'}</td>
                    </tr>
                    <tr>
                        <td><strong>Email</strong></td>
                        <td>{OrderInf.email || 'N/A'}</td>
                        <td><strong>DOB</strong></td>
                        <td>{OrderInf.dob || 'N/A'}</td>
                    </tr>
                    <tr>
                        <td><strong>Gender</strong></td>
                        <td>{OrderInf.gender || 'N/A'}</td>
                        <td><strong>Aadhar Number</strong></td>
                        <td>{OrderInf.adharnumber || 'N/A'}</td>
                    </tr>
                    <tr>
                        <td><strong>City</strong></td>
                        <td>{OrderInf.city || 'N/A'}</td>
                        <td><strong>State</strong></td>
                        <td>{OrderInf.state || 'N/A'}</td>
                    </tr>
                    <tr>
                        <td><strong>Pin Code</strong></td>
                        <td>{OrderInf.pincode || 'N/A'}</td>
                        <td><strong>Current Address</strong></td>
                        <td>{OrderInf.currentaddress || 'N/A'}</td>
                    </tr>
                    <tr>
                        <td><strong>Qualification</strong></td>
                        <td>{OrderInf.qualification || 'N/A'}</td>
                        <td><strong>Specialization</strong></td>
                        <td>{OrderInf.specialization || 'N/A'}</td>
                    </tr>
                    <tr>
                        <td><strong>Institution</strong></td>
                        <td>{OrderInf.institution_name || 'N/A'}</td>
                        <td><strong>Passed Out</strong></td>
                        <td>{OrderInf.passedout || 'N/A'}</td>
                    </tr>
                    <tr>
                        <td><strong>Languages</strong></td>
                        <td>{OrderInf.languages || 'N/A'}</td>
                        <td><strong>Sample Collection</strong></td>
                        <td>{OrderInf.sample_collection || 'N/A'}</td>
                    </tr>
                    <tr>
                        <td><strong>Two Wheeler</strong></td>
                        <td>{OrderInf.two_wheeler || 'N/A'}</td>
                        <td><strong>Phlebotomy Exp</strong></td>
                        <td>{OrderInf.phleblot_experience || 'N/A'}</td>
                    </tr>
                    <tr>
                        <td><strong>Total Years Of Experience</strong></td>
                        <td>{OrderInf.total_experience || 'N/A'}</td>
                        <td><strong>Previous Org</strong></td>
                        <td>{OrderInf.previous_organization || 'N/A'}</td>
                    </tr>
                    <tr>
                        <td><strong>Status</strong></td>
                        <td>{OrderInf.status || 'N/A'}</td>
                        <td><strong>License No.</strong></td>
                        <td>{OrderInf.license_number || 'N/A'}</td>
                    </tr>
                    <tr>
                        <td><strong>Resume (PDF)</strong></td>
                        <td colSpan="3">
                            {OrderInf.resume ? (
                                <a
                                    href={authService.getApiDomainUrl() + OrderInf.resume}
                                    target="_blank"
                                    rel="noreferrer"
                                    style={{ color: '#1890ff' }}
                                >
                                    View Resume
                                </a>
                            ) : 'N/A'}
                        </td>
                    </tr>
                    <tr>
                        <td><strong>Certificate</strong></td>
                        <td colSpan="3">
                            {OrderInf.certificate ? (
                                <a
                                    href={authService.getApiDomainUrl() + OrderInf.certificate}
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    <img
                                        src={authService.getApiDomainUrl() + OrderInf.certificate}
                                        alt="Certificate"
                                        style={{ width: 100, cursor: 'pointer' }}
                                    />
                                </a>
                            ) : 'N/A'}
                        </td>
                    </tr>
                    <tr>
                        <td><strong>ID Proof</strong></td>
                        <td colSpan="3">
                            {OrderInf.id_proof ? (
                                <a
                                    href={authService.getApiDomainUrl() + OrderInf.id_proof}
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    <img
                                        src={authService.getApiDomainUrl() + OrderInf.id_proof}
                                        alt="ID Proof"
                                        style={{ width: 100, cursor: 'pointer' }}
                                    />
                                </a>
                            ) : 'N/A'}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

export default PhlebloInfo;
